import React from 'react';
import { Navigate } from 'react-router-dom';

/** Base /settings/connections → the role's first sub-page. */
const ConnectionsIndex = ({ currentUser }) => {
  const isB2b = currentUser?.organizationType === 'B2B';
  return <Navigate to={isB2b ? '/settings/connections/clients' : '/settings/connections/providers'} replace />;
};

export default ConnectionsIndex;
